export const religiousAffiliation = new Map([
  [51, 'African Methodist Episcopal'],
  [24, 'African Methodist Episcopal Zion Church'],
  [52, 'American Baptist'],
  [22, 'American Evangelical Lutheran Church'],
  [27, 'Assemblies of God Church'],
  [54, 'Baptist'],
  [28, 'Brethren Church'],
  [34, 'Christ and Missionary Alliance Church'],
  [61, 'Christian Church (Disciples of Christ)'],
  [48, 'Christian Churches and Churches of Christ'],
  [55, 'Christian Methodist Episcopal'],
  [35, 'Christian Reformed Church'],
  [58, 'Church of Brethren'],
  [57, 'Church of God'],
  [59, 'Church of the Nazarene'],
  [74, 'Churches of Christ'],
  [60, 'Cumberland Presbyterian'],
  [50, 'Episcopal Church, Reformed'],
  [102, 'Evangelical Christian'],
  [36, 'Evangelical Congregational Church'],
  [37, 'Evangelical Covenant Church of America'],
  [38, 'Evangelical Free Church of America'],
  [39, 'Evangelical Lutheran Church'],
  [4, 'Free Methodist'],
  [41, 'Free Will Baptist Church'],
  [65, 'Friends'],
  [105, 'General Baptist'],
  [91, 'Greek Orthodox'],
  [42, 'Interdenominational'],
  [80, 'Jewish'],
  [68, 'Lutheran Church - Missouri Synod'],
  [67, 'Lutheran Church in America'],
  [43, 'Mennonite Brethren Church'],
  [69, 'Mennonite Church'],
  [87, 'Missionary Church Inc'],
  [44, 'Moravian Church'],
  [78, 'Multiple Protestant Denomination'],
  [106, 'Muslim'],
  [108, 'Non-Denominational'],
  [45, 'North American Baptist'],
  [100, 'Original Free Will Baptist'],
  [79, 'Other Protestant'],
  [47, 'Pentecostal Holiness Church'],
  [107, 'Plymouth Brethren'],
  [103, 'Presbyterian'],
  [66, 'Presbyterian Church (USA)'],
  [73, 'Protestant Episcopal'],
  [49, 'Reformed Church in America'],
  [81, 'Reformed Presbyterian Church'],
  [30, 'Roman Catholic'],
  [92, 'Russian Orthodox'],
  [95, 'Seventh Day Adventist'],
  [75, 'Southern Baptist'],
  [94, 'The Church of Jesus Christ of Latter-day Saints'],
  [97, 'The Presbyterian Church in America'],
  [88, 'Undenominational'],
  [93, 'Unitarian Universalist'],
  [84, 'United Brethren Church'],
  [76, 'United Church of Christ'],
  [71, 'United Methodist'],
  [89, 'Wesleyan'],
  [33, 'Wisconsin Evangelical Lutheran Synod'],
]);
